/**
 * main layout applied to all pages
 */


 import React from 'react'
 import layoutStyles from './layoutStyles.module.css'
 import Header from './header'
 import Footer from './footer'


  const Layout = (props) => {
    return(
      <div className = {layoutStyles.container}>
        <div className = {layoutStyles.content}>
        < Header / > {
            props.children
          } 
          </div>
          <Footer / >
      </div>
    )
  }

  export default Layout
